import {useEffect, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";

import {useAppDispatch} from "../../../../../utils/hooks/store_hooks";
import {getEntriesApi} from "../api/get_entries";
import {useSyncSubscriptionsMutation} from "../api/subscriptions_api";

export const useSubscriptionCheckoutReturnSync = (entryId?: string) => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const [syncSubscriptions] = useSyncSubscriptionsMutation();
    const hasSyncedRef = useRef(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (params.get("subscription") !== "success" || hasSyncedRef.current) {
            return;
        }

        hasSyncedRef.current = true;

        const sync = async () => {
            try {
                await syncSubscriptions().unwrap();

                if (entryId) {
                    dispatch(getEntriesApi.endpoints.getEntriesById.initiate(entryId, {forceRefetch: true}));
                }
            } catch {
                // Webhook may still be in flight; user can refresh manually.
            } finally {
                params.delete("subscription");
                const search = params.toString();

                history.replace({
                    pathname: location.pathname,
                    search: search ? `?${search}` : ""
                });
            }
        };

        sync();
    }, [dispatch, entryId, history, location.pathname, location.search, syncSubscriptions]);
};
